import axios from "axios";
import axiosUrl from "./axios.service";

const API_URL = axiosUrl.getAxiosUrl();
const BASE = API_URL + "EuCallSchemeMappings/";

// Surfaces the backend message (e.g. "A mapping for prefix '...' already exists.") so the
// DataGrid editing UI can show it.
const toError = error => {
  const message =
    error.response && error.response.data ? error.response.data : error.message;
  return new Error(message);
};

class EuCallSchemeMappingService {
  async getAll() {
    return await axios
      .get(BASE + "getAll")
      .then(response => response.data)
      .catch(error => {
        throw toError(error);
      });
  }

  async getEnglishSchemesForSelect(filter) {
    return await axios
      .get(BASE + "getEnglishSchemesForSelect", { params: { filter } })
      .then(response => response.data)
      .catch(error => {
        throw toError(error);
      });
  }

  async create(model) {
    return await axios
      .post(BASE + "create", model)
      .then(response => response.data)
      .catch(error => {
        throw toError(error);
      });
  }

  async update(model) {
    return await axios
      .put(BASE + "update", model)
      .then(response => response.data)
      .catch(error => {
        throw toError(error);
      });
  }

  async delete(id) {
    return await axios
      .delete(BASE + "delete", { params: { id } })
      .then(response => response.data)
      .catch(error => {
        throw toError(error);
      });
  }
}

export default new EuCallSchemeMappingService();
